<template>
  <div>
    <Header></Header>
    <div class="col-12 d-inline-flex">
      <div class="col-10 no-overflow ms-3 me-3 pt-3" style="position: relative;">
        <h2>Sessions</h2>
        <div class="d-flex justify-content-between align-items-center">
          <div class="d-flex justify-content-between align-items-center">
            <a role="button" class="procricket-btn mb-3" @click="openSearch">Search</a>
          </div>
          <div class="items-per-page-dropdown mb-3">
            <label>Items Per Page: </label>
            <select v-model="size" @change="updateItemsPerPage">
              <option value="20">20</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
          </div>
        </div>

        <div class="table-responsive">
          <table class="table table-striped table-bordered">
            <thead>
            <tr>
              <th class="col-1" @click="toggleSort('sessionId')">Session Id</th>
              <th class="col-1" @click="toggleSort('userId')">User Id</th>
              <th class="col-1" @click="toggleSort('region')">Region</th>
              <th class="col-1" @click="toggleSort('edgeAddress')">Edge Address</th>
              <th class="col-1" @click="toggleSort('protocol')">Protocol</th>
              <th class="col-1" @click="toggleSort('channelId')">Channel Name</th>
              <th class="col-1" @click="toggleSort('vidictId')">VidictId</th>
              <th class="col-1" @click="toggleSort('deviceOs')">Device Os</th>
              <th class="col-1" @click="toggleSort('deviceType')">Device Type</th>
              <th class="col-1" @click="toggleSort('appVersion')">App Version</th>
              <th class="col-1" @click="toggleSort('userAgent')">User Agent</th>
              <th class="col-1" @click="toggleSort('randomUUID')">randomUUID</th>
              <th class="col-1" @click="toggleSort('application')">application</th>
              <th class="col-1" @click="toggleSort('startTime')">Start Time</th>
              <th class="col-1" @click="toggleSort('endTime')">End Time</th>
              <th class="col-1">Edit</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="config in sortData" :key="config.sessionId">
              <td class="col-1 text-truncate" v-html="truncateText(config.sessionId, 10)"  @click="selectText" :data-text="config.sessionId" ></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.userId, 50)"  @click="selectText" :data-text="config.userId" ></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.region, 10)" @click="selectText" :data-text="config.region"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.edgeAddress, 30)" @click="selectText" :data-text="config.edgeAddress"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.protocol, 10)"  @click="selectText" :data-text="config.protocol" ></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.channelName, 10)"  @click="selectText" :data-text="config.channelName" ></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.vidictId, 50)" @click="selectText" :data-text="config.vidictId"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.deviceOs, 10)" @click="selectText" :data-text="config.deviceOs"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.deviceType, 10)"  @click="selectText" :data-text="config.deviceType" ></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.appVersion, 10)"  @click="selectText" :data-text="config.appVersion" ></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.userAgent, 30)" @click="selectText" :data-text="config.userAgent"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.randomUUID, 30)" @click="selectText" :data-text="config.randomUUID"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.application, 30)" @click="selectText" :data-text="config.application"></td>
              <td class="col-1 text-truncate" v-html="formatUnixTimestamp(config.startTime)" @click="selectText" :data-text="config.startTime"></td>
              <td class="col-1 text-truncate" v-html="formatUnixTimestamp(config.endTime)" @click="selectText" :data-text="config.endTime"></td>


              <td class="col-1 centered">
                <router-link :to="{ name: 'SessionEdit', params: { sessionId: config.sessionId, ...config } }" class="procricket-btn">
                  Edit
                </router-link>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <br>
        <vue-awesome-paginate
            :total-items="totalElements"
            :items-per-page="size"
            :max-pages-shown="5"
            v-model="page"
            :on-click="changePage"
        />
      </div>
    </div>
    <!-- Modal -->
    <div class="modal d-block" v-if="showSearch">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title fw-bold">Search in sessions</h4>
            <button role="button" class="close close-modal" data-dismiss="modal" aria-label="Close" @click="closeSearch">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form class="modal-form">
              <label>Session Id</label>
              <input type="text" v-model="searchFilters.sessionId">
              <label >User Id</label>
              <input type="text" v-model="searchFilters.userId">
              <label>User Email</label>
              <input type="text" v-model="searchFilters.email">
              <label>Region</label>
              <input type="text" v-model="searchFilters.region">
              <label >Edge Address</label>
              <input type="text" v-model="searchFilters.edgeAddress">
              <label>Protocol</label>
              <input type="text" v-model="searchFilters.protocol">
              <label >Channel id</label>
              <input type="text" v-model="searchFilters.channelId">
              <label>Vidict Id</label>
              <input type="text" v-model="searchFilters.vidictId">
              <label >Device Os</label>
              <input type="text" v-model="searchFilters.deviceOs">
              <label>Device Type</label>
              <input type="text" v-model="searchFilters.deviceType">
              <label >App Version</label>
              <input type="text" v-model="searchFilters.appVersion">
              <label >Start Time Range</label>
              <div class="d-flex">
                <input type="text" v-model="searchFilters.startTime" placeholder="YYYY-MM-DD hh:mm:ss" class="flex-grow-1 me-2">
                 <input type="text" v-model="searchFilters.endTime" placeholder="YYYY-MM-DD hh:mm:ss" class="flex-grow-1 ms-2">
              </div>
              <div class="d-flex mt-1">
              <label >End Time is null</label>
              <input type="checkbox" class="ms-2" v-model="searchFilters.isEndTimeNull">
              </div>
            </form>
            <div v-if="errorMessage !== ''" class="error-message">{{errorMessage}}</div>
          </div>
          <div class="modal-footer">
            <a class="btn cancel-btn" role="button" data-dismiss="modal" @click="closeSearch">Cancel</a>
            <a class="btn signout-popup text-white" role="button" @click="doLoadData">Search</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AdminService from "@/services/admin-service";
import Header from "@/components/Header.vue";
import {Sort, SessionRequest, SessionFilter} from "@/model/models";

export default {
  name: "Sessions",
  components: {
    Header,
  },
  data() {
    return {
      showSearch: false,
      page: 1,
      size: 20,
      totalElements: 0,
      sessionList: [],
      sortColumn: null,
      sortDirection: "ASC",
      errorMessage: null,
      searchFilters: new SessionFilter(null, null,null,null,null,null,null,null,null,null,null,null,null,null)
    };
  },
  computed: {
    sortData() {
      return this.sessionList;
    },
  },
  created() {
    this.doLoadData();
    document.addEventListener('click', (event) => this.handleClickAnywhere(event));
  },
  methods: {
    changePage(page) {
      this.page = page
      this.doLoadData()
    },
    doLoadData() {
      let request = new SessionRequest(
          this.page - 1,
          this.size
      );
      if (this.sortColumn != null) {
        request.sort = new Sort(this.sortColumn, this.sortDirection);
      }
      request.filter = new SessionFilter(
          this.searchFilters.sessionId, this.searchFilters.userId, this.searchFilters.email, this.searchFilters.edgeAddress, this.searchFilters.protocol,
          this.searchFilters.channelId, this.searchFilters.vidictId, this.searchFilters.region, this.searchFilters.deviceOs, this.searchFilters.deviceType,
          this.searchFilters.appVersion, this.dateToUnixTimestamp(this.searchFilters.startTime), this.dateToUnixTimestamp(this.searchFilters.endTime), this.searchFilters.isEndTimeNull
      );

      AdminService.getSessions(request).then((data) => {
        this.showSearch = false
        this.sessionList = data.sessionList;
        this.page = data.page + 1
        this.totalElements = data.totalElements
        this.searchFilters = new SessionFilter(
            data.filter.sessionId, data.filter.userId, data.filter.email, data.filter.edgeAddress, data.filter.protocol, data.filter.channelId, data.filter.vidictId, data.filter.region,
            data.filter.deviceOs, data.filter.deviceType, data.filter.appVersion, data.filter.startTime, data.filter.endTime, data.filter.isEndTimeNull
        );
      }).catch((error) => {
        if (error.response) {
          this.errorMessage = error.response.data.message;
        }
        console.log(error)
      });
    },
    openSearch() {
      this.searchFilters = new SessionFilter(null, null,null,null,null,null,null,null,null,null,null,null,null,null)
      this.page = 1
      this.showSearch = true
    },
    closeSearch() {
      this.searchFilters = new SessionFilter(null,null,null,null,null,null,null,null,null,null,null,null,null,null)
      this.showSearch = false
      this.errorMessage = null
    },
    redirectToCreate() {
      //this.$router.push({ name: '' });
    },
    wrapText(text, limit) {
      if (text.length > limit) {
        const firstLine = text.substring(0, limit);
        const secondLine = text.substring(limit);
        return `${firstLine}<br>${secondLine}`;
      } else {
        return text;
      }
    },
    truncateText(text, limit) {
      if (text === undefined || text ===null) {
        return null
      } else {
        return text.length > limit ? text.substring(0, limit) + '...' : text;
      }
    },
    async selectText(event) {
      const originalText = event.target.getAttribute('data-text');
      await navigator.clipboard.writeText(originalText);
      this.highlightElement(event.target);
    },
    highlightElement(element) {
      this.removeHighlight();
      element.style.backgroundColor = 'yellow'; // Add highlight
      this.highlightedElement = element;
      setTimeout(this.removeHighlight, 10000); // Remove highlight after 10 seconds
    },
    removeHighlight() {
      if (this.highlightedElement) {
        this.highlightedElement.style.backgroundColor = ''; // Remove highlight
        this.highlightedElement = null;
      }
    },
    handleClickAnywhere() {
      this.removeHighlight()
    },
    toggleSort(column) {
      if (this.sortColumn === column) {
        this.sortDirection = this.sortDirection === 'ASC' ? 'DESC' : 'ASC';
      } else {
        this.sortColumn = column;
        this.sortDirection = 'ASC';
      }
      this.doLoadData()
    },
    updateItemsPerPage() {
      this.doLoadData()
    },
    applyFilter(column) {
      // Implement filtering based on the search criteria for the selected column
      const filterValue = this.searchFilters[column].toLowerCase();

      const filteredData = this.dataRows.filter(row => {
        return row[column].toLowerCase().includes(filterValue);
      });

      // Update the dataRows with the filtered data
      this.dataRows = filteredData;
    },
    formatUnixTimestamp(timestamp) {
      if (timestamp) {
        const date = new Date(timestamp);
        const year = date.getUTCFullYear();
        const month = (date.getUTCMonth() + 1).toString().padStart(2, '0'); // Months are 0-based
        const day = date.getUTCDate().toString().padStart(2, '0');
        const hours = date.getUTCHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        const seconds = date.getSeconds().toString().padStart(2, '0');
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      } else {
        return null;
      }
    },
    dateToUnixTimestamp(dateString) {
       if (dateString !== undefined && dateString !== null) {
        const date = new Date(dateString);
        return date.getTime();
      } else return null
    }
  },
  mounted() {
    window.addEventListener('keyup', (event) => {
      if (event.key === 'Escape' && this.showSearch) {
        this.closeSearch();
      }
    });
  },
  beforeUnmount() {
    window.removeEventListener('keyup', this.closeSearch);
  }
};
</script>
<style src="../../assets/style.css">
</style>
